import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-a7a0ab00"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "text-analysis"
};
const _hoisted_2 = {
  class: "input-group"
};
const _hoisted_3 = {
  class: "input-pair"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "paragraphA"
}, "段落A:", -1));

const _hoisted_5 = {
  class: "input-pair"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "textB"
}, "文本B (段落A的一部分):", -1));

const _hoisted_7 = {
  class: "input-pair"
};
const _hoisted_8 = ["for"];
const _hoisted_9 = ["id", "onUpdate:modelValue"];
const _hoisted_10 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _withDirectives(_createElementVNode("textarea", {
    id: "paragraphA",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.paragraphA = $event),
    placeholder: "输入段落A"
  }, null, 512), [[_vModelText, $data.paragraphA, void 0, {
    trim: true
  }]])]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _withDirectives(_createElementVNode("input", {
    type: "text",
    id: "textB",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.textB = $event),
    placeholder: "输入文本B"
  }, null, 512), [[_vModelText, $data.textB, void 0, {
    trim: true
  }]])])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.paragraphsCandD, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "input-group"
    }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("label", {
      for: 'textD' + index
    }, "文本D" + _toDisplayString(index + 1) + " (段落C" + _toDisplayString(index + 1) + "的一部分):", 9, _hoisted_8), _withDirectives(_createElementVNode("input", {
      type: "text",
      id: 'textD' + index,
      "onUpdate:modelValue": $event => item.textD = $event,
      placeholder: "输入文本D"
    }, null, 8, _hoisted_9), [[_vModelText, item.textD, void 0, {
      trim: true
    }]])])]);
  }), 128)), _createElementVNode("button", {
    onClick: _cache[2] || (_cache[2] = (...args) => $options.addCDPair && $options.addCDPair(...args))
  }, "添加更多C/D对"), _createElementVNode("button", {
    onClick: _cache[3] || (_cache[3] = (...args) => $options.generateMessage && $options.generateMessage(...args))
  }, "生成"), $data.generatedMessage ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    onClick: _cache[4] || (_cache[4] = (...args) => $options.copyMessage && $options.copyMessage(...args))
  }, "复制文本")) : _createCommentVNode("", true), $data.copySuccess ? (_openBlock(), _createElementBlock("p", _hoisted_10, "文本已复制!")) : _createCommentVNode("", true)]);
}